import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { LoadingSpinner } from './LoadingSpinner';
import { useState } from 'react';
import { RateQuoteModal } from './Modals/RateQuoteModal';
import axios from 'axios';
import { MultiplePieceShipmentModal } from './Modals/MultiplePieceShipmentModal';
import { useNotifications } from '../contexts/NotificationsContext';
import { ShipmentHistoryModal } from './Modals/ShipmentHistoryModal';

export const Toolbar = ({ formik, submitLoading, onReturnTab, handleReset, updateHideLookup, resetTabs }) => {
    const { addNotification } = useNotifications();
    const [showRateQuoteModal, setShowRateQuoteModal] = useState(false);
    const [rateQuoteModalData, setRateQuoteModalData] = useState([]);
    const [rateQuoteLoading, setRateQuoteLoading] = useState(false);
    const [showMPSModal, setShowMPSModal] = useState(false);
    const [mpsPackagesOnOpen, setMpsPackagesOnOpen] = useState([]);
    const [shipmentRateQuoteValue, setShipmentRateQuoteValue] = useState(null);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const values = onReturnTab ? formik.values.returnData : formik.values;
    const isMps = values.mpsPackages.length > 0;
    const mpsPackagesField = onReturnTab ? 'returnData.mpsPackages' : 'mpsPackages';

    const handleShowRateQuoteModal = () => setShowRateQuoteModal(true);
    const handleCloseRateQuoteModal = () => setShowRateQuoteModal(false);
    const handleShowMPSModal = () => {
        setMpsPackagesOnOpen(values.mpsPackages);
        setShowMPSModal(true);
    }
    const handleCloseMPSModal = () => setShowMPSModal(false);
    const handleShowHistoryModal = () => setShowHistoryModal(true);
    const handleCloseHistoryModal = () => setShowHistoryModal(false);

    const revertMpsPackages = () => {
        formik.setFieldValue(mpsPackagesField, mpsPackagesOnOpen);
    }

    const getRateQuoteAndTransitTimes = async (showModal) => {
        setRateQuoteLoading(true);
        const { values } = formik;
        if (!isMps && (!values.shipperPostalCode || !values.shipperCountry || !values.postalCode || !values.country || !values.weightUnit || !values.weight)) {
            setRateQuoteLoading(false);
            return alert('The following fields are necessary for this function: postalCode, country, weight');
        }
        const url = `${process.env.REACT_APP_BASE_URL}/fedex/rates/quotes`;
        const reqBody = {
            accountNum: values.accountNum,
            shipper: {
                postalCode: values.shipperPostalCode,
                countryCode: values.shipperCountry,
                city: values.shipperCity,
                stateOrProvinceCode: values.shipperState
            },
            recipient: {
                postalCode: values.postalCode,
                countryCode: values.country,
                city: values.city,
                stateOrProvinceCode: values.stateProvince
            },
            weight: {
                units: values.weightUnit,
                value: values.weight
            },
            mpsPackages: values.mpsPackages
        }
        if (values.serviceType) {
            reqBody.serviceType = values.serviceType;
        }
        if (values.declaredValue) {
            reqBody.declaredValue = {
                amount: values.declaredValue,
                currency: values.declaredValueCurrency
            }
        }
        const { length, width, height, dimensionsUnit } = values;
        if (length && width && height && dimensionsUnit) {
            reqBody.dimensions = {
                length,
                width,
                height,
                units: dimensionsUnit
            }
        }
        if (values.country !== 'US') {
            reqBody.commodities = values.commodities;
        }

        try {
            const result = await axios.post(url, reqBody);
            const modalData = result.data.data;
            const selectedServiceObj = modalData.find((i) => i.service === values.serviceType);
            if (selectedServiceObj) {
                setShipmentRateQuoteValue(selectedServiceObj.yourRate);
            }
            setRateQuoteModalData(modalData);
            setRateQuoteLoading(false);
            if (showModal) {
                handleShowRateQuoteModal();
            }
        } catch (err) {
            setRateQuoteLoading(false);
            const errDetails = err.response.data.details.errors && err.response.data.details.errors.length > 0 ? err.response.data.details.errors[0].code : '';
            addNotification('Error getting rate quote and transit times.', errDetails || err.message, 'danger');
            console.log('Error fetching rate quote and transit times: ' + err);
        }
    }

    return (
        <>
            <div className='my-btn-toolbar'>
                <ButtonGroup className='my-btn-grp'>
                    <Button variant='secondary' onClick={handleReset}>Clear fields</Button>
                    {/* <Button variant="secondary">Delete/Modify shipment</Button>
                    <Button variant="secondary">Repeat shipment</Button> */}
                    {!onReturnTab &&
                        <Button variant='secondary' disabled={rateQuoteLoading} onClick={() => getRateQuoteAndTransitTimes(true)}>
                            {rateQuoteLoading ? <LoadingSpinner /> : 'Rate quote and transit times'}
                        </Button>}
                    <Button variant='secondary' onClick={handleShowHistoryModal}>Shipment history</Button>
                </ButtonGroup>
                <DropdownButton className='my-btn-dropdown' title='Form options' variant='secondary'>
                    <Dropdown.Item onClick={handleReset}>Clear fields</Dropdown.Item>
                    {/* <Dropdown.Item>Delete/Modify shipment</Dropdown.Item>
                    <Dropdown.Item>Repeat shipment</Dropdown.Item> */}
                    {!onReturnTab &&
                        <Dropdown.Item disabled={rateQuoteLoading} onClick={() => getRateQuoteAndTransitTimes(true)}>
                            {rateQuoteLoading ? <LoadingSpinner /> : 'Rate quote and transit times'}
                        </Dropdown.Item>}
                    <Dropdown.Item>Shipment history</Dropdown.Item>
                </DropdownButton>
                <ButtonGroup>
                    <Button onClick={handleShowMPSModal} variant='secondary' disabled={values.numPackages < 2 || values.identicalPackages} >
                        Multiple-piece shipment
                    </Button>
                    <Button type='submit' className='purple-btn' disabled={submitLoading}>
                        {submitLoading ? <LoadingSpinner /> : 'Ship'}
                    </Button>
                </ButtonGroup>
            </div>
            <RateQuoteModal formik={formik} show={showRateQuoteModal} handleClose={handleCloseRateQuoteModal} data={rateQuoteModalData} />
            <MultiplePieceShipmentModal
                formik={formik}
                show={showMPSModal}
                handleClose={handleCloseMPSModal}
                revertMpsPackages={revertMpsPackages}
                submitLoading={submitLoading}
                getRateQuoteAndTransitTimes={getRateQuoteAndTransitTimes}
                rateQuoteLoading={rateQuoteLoading}
                shipmentRateQuoteValue={shipmentRateQuoteValue}
                onReturnTab={onReturnTab}
            />
            <ShipmentHistoryModal
                formik={formik}
                show={showHistoryModal}
                handleClose={handleCloseHistoryModal}
                updateHideLookup={updateHideLookup}
                resetTabs={resetTabs}
            />
        </>
    )
}